import { router } from "./router.tsx"
import { RouterProvider } from "react-router-dom"
import dayjs from 'dayjs'
import utc from "dayjs/plugin/utc"
import relativeTime from "dayjs/plugin/relativeTime"
// antd v5 DatePicker/RangePicker drives dayjs and calls .weekday()/.localeData()
// etc. internally — without these plugins the picker panel throws
// "dayjs(...).weekday is not a function" on open.
import weekday from "dayjs/plugin/weekday"
import localeData from "dayjs/plugin/localeData"
import weekOfYear from "dayjs/plugin/weekOfYear"
import weekYear from "dayjs/plugin/weekYear"
import advancedFormat from "dayjs/plugin/advancedFormat"
import customParseFormat from "dayjs/plugin/customParseFormat"
import { useEffect } from "react"
import { loadGtag } from "./utils/gtag.ts"
import { UpgradePlate } from "./components/UpgradePlate.tsx"
import { SessionExpiredNotice } from "./components/SessionExpiredNotice.tsx"
import { CookieConsent } from "./components/CookieConsent.tsx"
import { useCookieConsent } from "./hooks/useCookieConsent.tsx"

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)


function App() {
    const { decided, analytics } = useCookieConsent()

    // Google Analytics only loads once the user has granted analytics consent.
    useEffect(() => {
        if (decided && analytics) loadGtag()
    }, [decided, analytics])

    return (
        <>
            <CookieConsent />
            <UpgradePlate />
            <SessionExpiredNotice />
            <RouterProvider router={router} />
        </>
    )
}

export default App
